import React from "react";
import "../Project/project.css";

const Project = () => (
  <div>
    <div className="t-title">
      <h1>Sobre este proyecto</h1>
    </div>
    <div className="main">
      <h2>40 figuritas por 40 años de democracia.</h2>

      <div className="first">
        <div className="col">
          <p className="text">
            Álbum Virtual de Figuritas sobre los 40 años de Democracia en la
            República Argentina
          </p>
          <p className="text">
            Esta propuesta surge del interés por ofrecer una mirada sobre la
            democracia argentina durante los últimos cuarenta años, a través de
            un dispositivo lúdico-didáctico con características interactivas. El
            propósito es contribuir a la educación de una ciudadanía
            comprometida con las instituciones, valores y prácticas
            democráticas.
          </p>
          <p className="text">
            Los contenidos fueron producidos y adaptados por un equipo
            interdisciplinario integrado por docentes investigadores e
            investigadoras del campo de las ciencias sociales de la Universidad
            Nacional de Rosario.
          </p>
        </div>
        <div className="col">
          <img src="../../../images/tapa-album.jpg" alt="" />
        </div>
      </div>

      <p>
        El álbum está destinado a estudiantes de nivel medio y universitario, y
        consiste en una selección de 40 figuritas que ilustran personajes y
        hechos de nuestra historia reciente. Asimismo, el proyecto contiene una
        línea de tiempo interactiva con información significativa sobre los
        hitos que marcaron estos años, desde 1983, y que forman parte de la
        historia argentina.
      </p>

      <p>
        <em>40 figuritas para 40 años de democracia</em> es una iniciativa de la
        universidad pública, para habitar las aulas presenciales y virtuales,
        junto a las adolescencias y las juventudes de todo el país.
      </p>
      <hr className="hr-l" />
      <h3><b>Idea y producción:</b></h3>

      <p>
        Escuela de Ciencia Política de la Facultad de
        Ciencia Política y Relaciones Internacionales; y Dirección de
        Comunicación de la Ciencia del Área Ciencia, Tecnología e Innovación
        para el Desarrollo de la Universidad Nacional de Rosario.
      </p>

      <p>
        <em>
          Proyecto ganador del Concurso Federal de Ideas Proyecto “Divulgación
          Científica” impulsado por el Ministerio de Ciencia, Tecnología e
          Innovación, a través del Centro Cultural de la Ciencia C3, y la
          Agencia Nacional de Promoción de la Investigación, el Desarrollo
          Tecnológico y la Innovación (Agencia I+D+i) PICT: 2019-02569. RES.
          2023-417.
        </em>
      </p>
      <hr className="hr-l" />

      <h3>
      <b>Participaron de este proyecto:</b>
      </h3>

      <p>
        Cintia Pinillos - Esteban Iglesias - María Soledad Casasola - Sebastián
        Castro Rojas – Gisela Pereyra Doval - Natalia Fernandez Baez - Juan
        Bautista Lucca - Alberto Ford – Sabrina Benedetto - Mario Gluck -
        Ezequiel Berlochi - Melina Perbellini - Osvaldo Iazzetta – Gladys
        Lecchini - Muriel Sanchez - Lucas Massuco - Carla Vigil.
      </p>

      <hr className="hr-l" />
      <p>
        <em>
          Las imágenes que ilustran este proyecto fueron diseñadas a partir de
          los registros fotográficos de la época, publicados en los diarios
          Clarín, La Nación y Página12.
        </em>
      </p>
    </div>
  </div>
);

export default Project;
